import { observer } from 'mobx-react-lite'
import React, { Fragment, useContext, useMemo } from 'react'
import { CampaignContext } from '../../../../contexts/CampaignContext'
import Influencers from './BudgetTableParts/Influencers'
import Overview from './BudgetTableParts/Overview'

export default observer(function BudgetTable() {
  const { campaignScenarios } = useContext(CampaignContext)

  const campaignScenario = useMemo(() => campaignScenarios[0], [campaignScenarios.length, campaignScenarios])

  return (
    <div className="pt-14 px-4 dark:bg-rb-dark-mode-background" style={{ minWidth: '82vw' }}>
      {campaignScenario &&
        <Fragment>
          <Overview campaignScenario={campaignScenario} />
          <Influencers campaignScenario={campaignScenario} />
        </Fragment>}
    </div>
  )
})
